import { FlexiText } from "appworks/graphics/elements/flexi-text";
import { AbstractControl } from "appworks/ui/controls/abstract-control";
import { gamevy } from "gamevy/gamevy";

export class EpicSpinIDControl extends AbstractControl {
    constructor(protected label: FlexiText) {
        super();

        this.updateID();
        gamevy.gameInstanceIDUpdated.add((id?: number) => this.updateID(id));
    }

    protected updateID(id?: number) {
        if (id !== undefined) {
            this.label.setText(`ID: ${id}`);
        }
    }
}
